import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-umokkur',
  templateUrl: './umokkur.component.html',
  styleUrls: ['./umokkur.component.css']
})
export class UmokkurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
